import React, { memo } from "react";
import * as R from "ramda";
import { Text, View } from "../../Base";

export default memo(
  ({ header, subheader, classes }) => (
    <View className={classes.container}>
      {!R.isNil(subheader) && (
        <Text noWrap className={classes.subheader}>
          {subheader}
        </Text>
      )}
      <Text noWrap className={classes.header}>
        {header}
      </Text>
    </View>
  ),
  (prevProps, nextProps) =>
    prevProps.header === nextProps.header &&
    prevProps.subheader === nextProps.subheader
);
